var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import * as dayjs from 'dayjs';
import translations from '../../common/sport/translations';
import css from './style.pcss';
import { helper } from "../../common/helper";
import DefaultPlayerImage from "./images/football-player.png";
var RTLSportStatistics = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLSportStatistics, _LitElement);
  function RTLSportStatistics() {
    var _this;
    _classCallCheck(this, RTLSportStatistics);
    _this = _callSuper(this, RTLSportStatistics);
    _this.language = 'lu';
    _this.type = 'top-scorers'; // cards, assists
    _this.limit = 999;
    _this.countByPage = 20;
    _this.page = 0;
    _this.typeList = ['top-scorers',
    // 'assists',
    'cards'];
    if (window.rtlsites) {
      _this.language = window.rtlsites.config.language;
    }
    return _this;
  }
  _createClass(RTLSportStatistics, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLSportStatistics.prototype), "connectedCallback", this).call(this);
      this._fetchData();
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      var apiUrl = "https://api-gate.rtl.lu/sport";
      if (!this.type) this.type = 'top-scorers';
      apiUrl += `/statistics/${this.type}?limit=${this.limit}&lang=${this.language}`;
      fetch(apiUrl).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.data = resp;
      });
    }
  }, {
    key: "_getTranslation",
    value: function _getTranslation(key) {
      if (!translations[key]) {
        console.warn(key + ' is not defined in translations.js!');
      } else return translations[key][this.language];
    }
  }, {
    key: "_switchType",
    value: function _switchType(e, type) {
      var link = this._getLink();
      document.location.href = `${link}/statistics?c=${this.competition}&p=0&type=${type}`;
    }
  }, {
    key: "_getLink",
    value: function _getLink() {
      var link;
      if (this.language === 'fr') link = `/sport/resultats`;
      if (this.language === 'lu') link = `/sport/${this._getTranslation('sport' + this.sport)}/resultater`;
      return link;
    }
  }, {
    key: "_showPlayer",
    value: function _showPlayer(e, id) {
      var link = this._getLink();
      document.location.href = `${link}/teams/player?c=${this.competition}&p=${id}`;
    }
  }, {
    key: "_getPosition",
    value: function _getPosition(items, item, i) {
      var position = '';
      if (i === 0) {
        position = item.position;
      } else {
        if (items[i - 1].position !== item.position) position = item.position;
      }
      return position;
    }
  }, {
    key: "_renderTopScorer",
    value: function _renderTopScorer(items) {
      var _this3 = this;
      return html(_t || (_t = _`
            <table class="sport-stats-table">
                <tr>
                    <th class="sport-stats-table__th"></th>
                    <th class="sport-stats-table__th"></th>
                    <th class="sport-stats-table__th"></th>
                    <th class="sport-stats-table__th">${0}</th>
                    <th class="sport-stats-table__th">${0}</th>
                    <th class="sport-stats-table__th">${0}</th>
                </tr>
                ${0}
            </table>
        `), this._getTranslation('matches_count'), this._getTranslation('penalty_count'), this._getTranslation('goals'), items.map(function (item, i) {
        var playerImg = `${DefaultPlayerImage}`;
        if (item.image_url) playerImg = item.image_url;
        return html(_t2 || (_t2 = _`
                       <tr>
                           <td class="sport-stats-table__td sport-stats-table__td--rank">${0}</td>
                           <td class="sport-stats-table__td sport-stats-table__image" @click=${0}>
                               <img src="${0}" alt="${0}" width="100" />
                               <img class="sport-stats-table__team" src="${0}" alt="${0}" width="50" />
                           </td>
                           <td class="sport-stats-table__td sport-stats-table__td--left">
                               <span class="sport-stats-table__player" @click=${0}>${0}<br/><b>${0}</b></span>
                           </td>
                           <td class="sport-stats-table__td">${0}</td>
                           <td class="sport-stats-table__td">${0} / ${0}</td>
                           <td class="sport-stats-table__td">${0}</td>
                       </tr>
                    `), _this3._getPosition(items, item, i), function (e) {
          return _this3._showPlayer(e, item.id);
        }, helper.stockify(playerImg, 100), item.formatted_name, item.team.logo_url, item.formatted_name, function (e) {
          return _this3._showPlayer(e, item.id);
        }, item.first_name, item.last_name, item.statistics.matches_played, item.statistics.penalty_shots_hit, item.statistics.penalty_shots, item.statistics.goals);
      }));
    }
  }, {
    key: "_renderAssists",
    value: function _renderAssists(items) {
      var _this4 = this;
      return html(_t3 || (_t3 = _`
            <table class="sport-stats-table">
                <tr>
                    <th class="sport-stats-table__th"></th>
                    <th class="sport-stats-table__th"></th>
                    <th class="sport-stats-table__th"></th>
                    <th class="sport-stats-table__th">${0}</th>
                    <th class="sport-stats-table__th">${0}</th>
                </tr>
                ${0}
            </table>
        `), this._getTranslation('matches_count'), this._getTranslation('assists'), items.map(function (item, i) {
        var playerImg = `${DefaultPlayerImage}`;
        if (item.image_url) playerImg = item.image_url;
        return html(_t4 || (_t4 = _`
                       <tr>
                           <td class="sport-stats-table__td sport-stats-table__td--rank">${0}</td>
                           <td class="sport-stats-table__td sport-stats-table__image" @click=${0}>
                               <img src="${0}" alt="${0}" width="100" />
                               <img class="sport-stats-table__team" src="${0}" alt="${0}" width="50" />
                           </td>
                           <td class="sport-stats-table__td sport-stats-table__td--left">
                               <span class="sport-stats-table__player" @click=${0}>${0}<br/><b>${0}</b></span>
                           </td>
                           <td class="sport-stats-table__td">${0}</td>
                           <td class="sport-stats-table__td">${0}</td>
                       </tr>
                    `), _this4._getPosition(items, item, i), function (e) {
          return _this4._showPlayer(e, item.id);
        }, helper.stockify(playerImg, 100), item.formatted_name, item.team.logo_url, item.formatted_name, function (e) {
          return _this4._showPlayer(e, item.id);
        }, item.first_name, item.last_name, item.statistics.matches_played, item.statistics.assists);
      }));
    }
  }, {
    key: "_renderCards",
    value: function _renderCards(items) {
      var _this5 = this;
      return html(_t5 || (_t5 = _`
            <table class="sport-stats-table">
                <tr>
                    <th class="sport-stats-table__th"></th>
                    <th class="sport-stats-table__th"></th>
                    <th class="sport-stats-table__th"></th>
                    <th class="sport-stats-table__th">${0}</th>
                    <th class="sport-stats-table__th">${0}</th>
                    <th class="sport-stats-table__th">${0}</th>
                    <th class="sport-stats-table__th">${0}</th>
                    <th class="sport-stats-table__th">${0} *</th>
                </tr>
                ${0}
            </table>
            <p>* ${0}</p>
        `), this._getTranslation('matches_count'), this._getTranslation('yellow_cards_info'), this._getTranslation('yellow_red_cards_info'), this._getTranslation('red_cards_info'), this._getTranslation('points'), items.map(function (item, i) {
        var playerImg = `${DefaultPlayerImage}`;
        if (item.image_url) playerImg = item.image_url;
        return html(_t6 || (_t6 = _`
                               <tr>
                                   <td class="sport-stats-table__td sport-stats-table__td--rank">${0}</td>
                                   <td class="sport-stats-table__td sport-stats-table__image" @click=${0}>
                                       <img src="${0}" alt="${0}" width="100" />
                                       <img class="sport-stats-table__team" src="${0}" alt="${0}" width="50" />
                                   </td>
                                   <td class="sport-stats-table__td sport-stats-table__td--left">
                                       <span class="sport-stats-table__player" @click=${0}>${0}<br/><b>${0}</b></span>
                                   </td>
                                   <td class="sport-stats-table__td">${0}</td>
                                   <td class="sport-stats-table__td">${0}</td>
                                   <td class="sport-stats-table__td">${0}</td>
                                   <td class="sport-stats-table__td">${0}</td>
                                   <td class="sport-stats-table__td">${0}</td>
                               </tr>
                            `), _this5._getPosition(items, item, i), function (e) {
          return _this5._showPlayer(e, item.id);
        }, helper.stockify(playerImg, 100), item.formatted_name, item.team.logo_url, item.formatted_name, function (e) {
          return _this5._showPlayer(e, item.id);
        }, item.first_name, item.last_name, item.statistics.matches_played, item.statistics.yellow_cards, item.statistics.yellow_red_cards, item.statistics.red_cards, item.statistics.card_score);
      }), this._getTranslation('top_cards_legend'));
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;
      if (this.data === undefined) return html(_t7 || (_t7 = _`Loading...`));
      var output;
      var pages = Math.ceil(this.data.length / 20);
      var dataFiltered = this.data.splice(this.page * this.countByPage, this.page * this.countByPage + this.countByPage);
      switch (this.type) {
        case 'assists':
          output = this._renderAssists(dataFiltered);
          break;
        case 'cards':
          output = this._renderCards(dataFiltered);
          break;
        default:
          output = this._renderTopScorer(dataFiltered);
      }
      var pageData = [];
      var link = this._getLink();
      for (var i = 0; i < pages; i++) {
        pageData.push({
          url: `${link}/statistics?c=${this.competition}&type=${this.type}&p=${i}`
        });
      }
      pageData = JSON.stringify(pageData);
      return html(_t8 || (_t8 = _`
            <style>${0}</style>

            <ul class="sport-stats-nav">
            ${0}
            </ul>

            <div class="sport-stats">
                ${0}

                ${0}
            </div>
        `), css, this.typeList.map(function (type) {
        return html(_t9 || (_t9 = _`
                <li class="sport-stats-nav__item${0}" @click=${0}>${0}</li>
            `), _this6.type === type ? ' sport-stats-nav__item--active' : '', function (e) {
          return _this6._switchType(e, type);
        }, _this6._getTranslation(type));
      }), output, pages > 1 ? html(_t10 || (_t10 = _`<div class="sport-stats__pager"><rtl-pager data="${0}" activepage="${0}"></rtl-pager></div>`), pageData, this.page) : '');
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        sport: {
          type: Number
        },
        // 1: Football / 2: Basketball / 3: Handball / 4: Volleyball / 5: Deschtennis
        competition: {
          type: Number
        },
        language: {
          type: String
        },
        type: {
          type: String
        },
        // top-scorers, assists, cards
        page: {
          type: Number
        }
      };
    }
  }]);
  return RTLSportStatistics;
}(LitElement);
export { RTLSportStatistics as default };
window.customElements.define('rtl-sport-statistics', RTLSportStatistics);